import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import pixel from "../../landing/pixel"
import Logo from "../../common/Logo"
import UserInformationForm from "./UserInformationForm"
import "./UserInformation.css"

const UserInformation = ({ user }) => {
  useEffect(
    () => {
      const script = document.createElement("script")
      if (process.env.REACT_APP_ENV === "production") {
        pixel.track("StartTrial")
        window.gtag("set", "conversion", {
          user_id: user.account.uuid
        })
        script.src = `https://track.omguk.com/2017697/e/ss/?APPID=${
          user.account.uuid
        }&MID=2017697&PID=37193&status=`
        script.async = true

        document.body.appendChild(script)
      }
      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script)
        }
      }
    },
    [user.account.uuid]
  )
  return (
    <div className="UserInformation">
      <Helmet>
        <script
        >{`OMID=2017697;OPID=37193;ORef=escape(window.parent.location.href);!function(){var a=document.createElement("script");a.type="text/javascript",a.async=!0,a.src="//track.omguk.com/e/qs/?action=Content&MID=" + OMID + "&PID=" + OPID + "&ref="+ ORef;var b=document.getElementsByTagName("body")[0];if(b)b.appendChild(a,b);else{var b=document.getElementsByTagName("script")[0];b.parentNode.insertBefore(a,b)}}();`}</script>
      </Helmet>
      <div className="box">
        <Logo />
        <h1>User Information</h1>
        <p>Complete your user information details.</p>
        <UserInformationForm />
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  user: state.user || null
})

export default connect(mapStateToProps)(UserInformation)
